
export class stream {
    id:number;
    streamName :string;
    universityId :number=1;
    }